var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'profileApartmentOne-component' : true,
              'profileApartmentOne-component-mob': _vm.$vuetify.breakpoint.xsOnly}},[(!_vm.withoutTabs.includes(_vm.$route.name))?_c('NavigationPanel',{attrs:{"tabs":_vm.subLinks}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }